import { render, staticRenderFns } from "./errors.vue?vue&type=template&id=eb058876&"
import script from "./errors.vue?vue&type=script&lang=js&"
export * from "./errors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports